// Owns the signature markup for EmailProvider's defaultBody seed, the Field Agent serializer in
// proposalApply, and FieldAgentEmailModal's own body seed. The composer's AI-insert path uses
// appendSignature instead, which emits a different shape.
const appendEmailSignature = (body: string, signatureText: string): string =>
  signatureText ? `${body}<div></div><div></div>${signatureText}` : body;

export default appendEmailSignature;
